import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteLegalClientMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';

export const useDeleteLegalClient = () => {
  const [handle, { loading, error: apolloError }] =
    useDeleteLegalClientMutation();
  const notifyMessage = useNotifyMessages();

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteLegalClient: useCallback(
      async (id: string) => {
        const res = await handle({
          variables: {
            id,
          },
        });

        notifyMessage(res.data?.deleteLegalClient?.messages);

        return res.data?.deleteLegalClient?.data;
      },
      [handle, notifyMessage]
    ),
  };
};
